import { getBackendUrl } from "@Utils";
import { DataManager, WebMethodAdaptor } from "@syncfusion/ej2-data";

// WebMethodAdaptor.prototype.beforeSend = (_, request) => {
//   request.withCredentials = true;
// };

class CustomAdaptor extends WebMethodAdaptor {
  private customProcessResponse: any;

  constructor(customProcessResponse: any) {
    super();
    this.customProcessResponse = customProcessResponse;
  }

  processResponse(data: any, instance?: any, value?: any, httpRequest?: any, request?: any, changes?: any): any {
    let originalValue = super.processResponse(data, instance, value, httpRequest, request, changes);
    if (changes != null) {
      originalValue = changes;
    }
    const result = this.customProcessResponse(originalValue);
    return result;
  }
}

export const getDataManagerObj = (url: string, processResponse?: any): DataManager => {
  let adaptor: WebMethodAdaptor | CustomAdaptor = new WebMethodAdaptor();

  if (processResponse) {
    adaptor = new CustomAdaptor(processResponse);
  }

  const dataManager = new DataManager({
    url,
    adaptor,
  });

  dataManager.adaptor.beforeSend = (_: any, request: any, settings: any) => {
    settings.fetchRequest = new Request(settings.url, {
      method: settings.fetchRequest.method,
      body: settings.data,
      headers: { "Content-Type": settings.contentType },
      credentials: "include",
    });
  };

  return dataManager;
};

export const accessTemplateUrl = `${getBackendUrl()}/permissions/accessTemplateController`;
export const spacesDataUrl = `${getBackendUrl()}/spaces/spacesData`;
export const includedProjectsUrl = `${getBackendUrl()}/projects/getIncludedProjectsController`;
export const issuesCustomFieldsUrl = `${getBackendUrl()}/issues/getCustomFields`;
export const portalProjectsUrl = `${getBackendUrl()}/portal/getProjectsList`;
export const companyAllUsersUrl = `${getBackendUrl()}/companies/allUsersController`;
export const companyUsersUrl = `${getBackendUrl()}/companies/usersController`;
export const inviteUsersUrl = `${getBackendUrl()}/accounts/inviteUsers`;
export const excludedUsersUrl = `${getBackendUrl()}/accounts/excludedUsersController`;
export const includedUsersUrl = `${getBackendUrl()}/accounts/includedUsersController`;
export const companyInvitedUsersUrl = `${getBackendUrl()}/companies/invitedUsersController`;
export const portalCompaniesUrl = `${getBackendUrl()}/companies/companiesController`;
export const positionDataUrl = `${getBackendUrl()}/positions/positionsController`;
export const portalUsersUrl = `${getBackendUrl()}/portal/getPortalUsers`;
export const portalProfilesUrl = `${getBackendUrl()}/portal/getPortalProfiles`;
export const estimateListUrl = `${getBackendUrl()}/estimate/getEstimateList`;
export const tasksListUrl = `${getBackendUrl()}/tasks/tasksController`;
export const estimateFilesUrl = `${getBackendUrl()}/estimate/getEstimateFiles`;
export const estimateItemsUrl = `${getBackendUrl()}/estimate/getEstimateItems`;
export const estimateTakeoffsListUrl = `${getBackendUrl()}/takeoffs/getTakeoffsList`;
export const takeoffAutomationUrl = `${getBackendUrl()}/takeoffs/getAutomationQueries`;
export const estimateMeasurementsUrl = `${getBackendUrl()}/measurements/getMeasurements`;
export const unitTypesUrl = `${getBackendUrl()}/units/getUnitTypes`;
export const portalMeasurementUnitsUrl = `${getBackendUrl()}/units/getMeasurementUnits`;
export const portalPurchaseUnitsUrl = `${getBackendUrl()}/units/getPurchaseUnits`;
export const getTransmittalDataUrl = `${getBackendUrl()}/transmittals/getTransmittalData`;
export const queriesUrl = `${getBackendUrl()}/queries/queriesData`;
export const assetListUrl = `${getBackendUrl()}/assets/assetListController`;
export const assetTypeUrl = `${getBackendUrl()}/assets/assetTypeController`;
export const changeOrderUrl = `${getBackendUrl()}/changeOrder/changeOrderController`;
export const costDatabaseUrl = `${getBackendUrl()}/dsr/portalGraph`;
export const ganttListUrl = `${getBackendUrl()}/tasks/getScheduleData`;
export const resourceTypesUrl = `${getBackendUrl()}/resources/getResourceTypes`;
export const resourceUrl = `${getBackendUrl()}/resources/getResources`;
export const unassignedTasksUrl = `${getBackendUrl()}/tasks/getScheduleUnassignedTasks`;
export const getDistinctFilePropertyValuesUrl = `${getBackendUrl()}/queries/getDistinctFilePropertyValues`;
export const getFilePropertiesUrl = `${getBackendUrl()}/queries/queryFileProperties`;
export const getCurrencyDataUrl = `${getBackendUrl()}/currency/getCurrencyData`;
export const getClashTestUrl = `${getBackendUrl()}/clashTests/getClashDetectionsList`;
export const getProjectRulesUrl = `${getBackendUrl()}/projectRulesController/getProjectRules`;
export const getDsrDataUrl = `${getBackendUrl()}/dsr/getDsrData`;
export const orgStructureServiceUrl = `${getBackendUrl()}/orgStructure/orgStructureController`;
export const orgTypeServiceUrl = `${getBackendUrl()}/orgStructure/getOrgTypes`;
export const orgStructureHeldByUrl = `${getBackendUrl()}/orgStructure/getOrganisationUsers`;
export const orgStructureReportsToUrl = `${getBackendUrl()}/orgStructure/getOrganisationReportsToData`;
export const getSelectionsDataUrl = `${getBackendUrl()}/selectionSet/getSelections`;
export const modelTreeUrl = `${getBackendUrl()}/queries/getModelTree`;
export const getSpacesList = `${getBackendUrl()}/spaces/getSpacesList`;
export const getSpaceUsersList = `${getBackendUrl()}/spaces/getSpaceUsersList`;
export const getIssuesUrl = `${getBackendUrl()}/issues/getIssuesDataByPortal`;
// export const getFilesList = `${getBackendUrl()}/projects/projectLevelFiles`;
export const getFilesList = `${getBackendUrl()}/projects/getFilesList`;
export const getValidItems = `${getBackendUrl()}/dsr/getValidItemsToImportInBoq`;
export const getDsrItemsUrl = `${getBackendUrl()}/dsr/getAllDsrItems`;
export const getValidItemsUrl = `${getBackendUrl()}/estimate/getValidItems`;
export const getAllVersionsOfDsrUrl = `${getBackendUrl()}/dsr/getAllVersionsOfDsr`;
export const getOnlyNodesOfModelUrl = `${getBackendUrl()}/queries/getOnlyNodesOfModel`;
export const performGanttOperationsUrl = `${getBackendUrl()}/tasks/performGanttOperations`;
export const performGanttOperationsUrlNew = `${getBackendUrl()}/tasks/performGanttOperationsNew`;
export const workflowsUrl = `${getBackendUrl()}/workflows/workflowsService`;
export const workflowReviewLevelsUrl = `${getBackendUrl()}/workflows/workflowReviewLevelsService`;
export const reviewsUrl = `${getBackendUrl()}/reviews/reviewsService`;
export const reviewsLevelUrl = `${getBackendUrl()}/reviews/reviewsLevelService`;
export const getResourcesInReviewUrl = `${getBackendUrl()}/reviews/getResourcesInReviewService`;
export const getTimePeriodsTypesUrl = `${getBackendUrl()}/workflows/getTimePeriodsTypes`;
export const userTypesUrl = `${getBackendUrl()}/workflows/getUserTypes`;
export const spaceUsersListUrl = `${getBackendUrl()}/workflows/getSpaceUsersList`;
export const getClashDetectionVersionResultOperationsUrl = `${getBackendUrl()}/clashTests/getClashDetectionVersionResult`;
export const getProjectTeamsUrl = `${getBackendUrl()}/projects/teamsController`;
export const locationUrl = `${getBackendUrl()}/projects/locationController`;
export const FormTypeUrl = `${getBackendUrl()}/forms/formTypesController`;
export const FormUrl = `${getBackendUrl()}/forms/formController`;
export const GroupUrl = `${getBackendUrl()}/groups/updateGroupsData`;
export const SpaceGroupsUrl = `${getBackendUrl()}/groups/spaceGroupsController`;
export const taskInspectionAndProgressFormUrl = `${getBackendUrl()}/forms/taskInspectionAndProgressFormsController`;
export const additionalCostsUrl = `${getBackendUrl()}/estimate/getAdditionalCost`;
export const statusListInWorkflowUrl = `${getBackendUrl()}/workflows/getStatusListInWorkflow`;
export const transitionsUrl = `${getBackendUrl()}/workflows/transitionsService`;
export const getPortalLevelStatusListUrl = `${getBackendUrl()}/portal/getPortalLevelStatusList`;
export const listOfStatusAvailableUrl = `${getBackendUrl()}/reviews/fetchListOfStatusesAvailable`;
export const defaultListOfStatusAvailableUrl = `${getBackendUrl()}/reviews/fetchDefaultListOfStatusesAvailable`;
export const activityLogsUrl = `${getBackendUrl()}/activity/activityLogs`;
export const formFlowServiceUrl = `${getBackendUrl()}/forms/formFlowController`;
export const constituentFilesOfMergedFileUrl = `${getBackendUrl()}/fileOperations/getConstituentFilesOfMergedFile`;
export const getConstituentFilesMatrix = `${getBackendUrl()}/fileOperations/saveConstituentMatrix`;
export const projectUsersUrl = `${getBackendUrl()}/projects/getProjectUsersList`;
export const mailsUrl = `${getBackendUrl()}/mailbox/getMails`;
export const formUsersUrl = `${getBackendUrl()}/accounts/getUsersList`;
export const getProjectVisibilityUsersUrl = `${getBackendUrl()}/projects/getProjectVisibilityUsers`;
export const getProjectWhitelistEmailsUrl = `${getBackendUrl()}/projects/getProjectWhitelistEmails`;
export const reviewsForResourceUrl = `${getBackendUrl()}/reviews/getReviewsListForEntity`;
export const contractsControllerUrl = `${getBackendUrl()}/contracts/contractsController`;
export const contractItemsUrl = `${getBackendUrl()}/contracts/getContractLinkedBoqItems`;
export const contractEntitiesUrl = `${getBackendUrl()}/contracts/getContractLinkedEntities`;
export const mileStoneServiceUrl = `${getBackendUrl()}/contracts/mileStoneController`;
export const resourceActivityInReviewUrl = `${getBackendUrl()}/reviews/getResourceActivityInReview`;
export const chargesUrl = `${getBackendUrl()}/estimate/chargesList`;
export const getFormMileStonesUrl = `${getBackendUrl()}/contracts/getFormMileStones`;
export const WBSServicesUrl = `${getBackendUrl()}/projects/WBSController`;
export const contractWBSServicesUrl = `${getBackendUrl()}/contracts/contractWBSController`;
export const getProjectRolesUrl = `${getBackendUrl()}/projects/getProjectRoles`;
export const getEscrowFileBatchesUrl = `${getBackendUrl()}/escrow/getEscrowFileBatches`;
export const getStatusList = `${getBackendUrl()}/statusList/getStatusList`;
export const estimateItemsForContractUrl = `${getBackendUrl()}/contracts/estimateItemsForContract`;
export const inactiveUsersUrl = `${getBackendUrl()}/accounts/inactiveUsers`;
export const projectTemplatesUrl = `${getBackendUrl()}/projectTemplates/projectTemplateData`;
export const spacesInProjectTemplateUrl = `${getBackendUrl()}/projectTemplates/spacesDataInProjectTemplate`;
export const getEntitesFromLibraryUrl = `${getBackendUrl()}/forms/getEntitesFromLibrary`;
export const newRegisterUrl = `${getBackendUrl()}/accounts/register1`;

export const estimateItemsForContractService = getDataManagerObj(estimateItemsForContractUrl);
export const getValidItemsService = getDataManagerObj(getValidItemsUrl);
export const getPortalLevelStatusListService = getDataManagerObj(getPortalLevelStatusListUrl);
